import { render, staticRenderFns } from "./SelectActividades.vue?vue&type=template&id=7156795e"
import script from "./SelectActividades.vue?vue&type=script&lang=js"
export * from "./SelectActividades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports